<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="true"></loading>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('receptions.list')">Modification d'un poste</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ repair.id }}
    </h1>
    <div class="bg-white rounded shadow overflow-hidden max-w-7xl pt-4">
      <form @submit.prevent="submit">
        <div class="md:inline-flex space-y-4 md:space-y-0 w-full py-4 px-6 items-center" :class="{'opacity-25 pointer-events-none' : repair.client == null}">
          <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Client:</h2>
          <div class="md:w-2/3 mx-auto">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-2">
                <text-input v-model="form.client.first_name" :error="errors.first_name" label="Prenom"/>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <text-input v-model="form.client.last_name" :error="errors.last_name" label="Nom"/>
              </div>
              <div class="col-span-6 sm:col-span-2">
                <text-input v-model="form.client.phone_number" :error="errors.phone_number" label="Telephone"/>
              </div>
              <div class="col-span-6 sm:col-span-3">
                <text-input type="email" v-model="form.client.email" :error="errors.email" label="Email"/>
              </div>
              <div class="col-span-6 sm:col-span-3">
                <select-input v-model="form.client.type" :error="errors.type" class="" label="Source">
                  <option v-for="type in clientTypes" :value="type">{{ type }}</option>
                </select-input>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden sm:block">
          <div class="py-6">
            <div class="border-t border-gray-200"></div>
          </div>
        </div>

        <div class="md:inline-flex space-y-4 md:space-y-0 w-full p-4 items-center">

          <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Reception:</h2>

          <div class="md:w-2/3 mx-auto grid grid-cols-6 gap-6">

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Ville:</label>
              <multiselect v-model="form.reception.city" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="cities"
                           :error="errors.city" :searchable="true" open-direction="bottom">
              </multiselect>
              <div v-if="errors.city_id" class="form-error">{{ errors.city_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Operateur:</label>
              <multiselect v-model="form.reception.operator" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="operators"
                           :error="errors.operator" :searchable="true" open-direction="bottom">
              </multiselect>
              <div v-if="errors.operator_id" class="form-error">{{ errors.operator_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Agence:</label>
              <multiselect v-model="form.reception.agency" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="agencies"
                           :error="errors.agency" :searchable="true" open-direction="bottom">
              </multiselect>
              <div v-if="errors.agency_id" class="form-error">{{ errors.agency_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Arrivé Par:</label>
              <multiselect v-model="form.reception.agent" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="agents" :searchable="true" :error="errors.agent" :clear-on-select="false"
                           open-direction="bottom">
              </multiselect>
              <div v-if="errors.agent_id" class="form-error">{{ errors.agent_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <text-input v-model="form.reception.caseNo" :error="errors.caseNo" label="N Case" :optional="true" autocomplete="off"/>
            </div>

          </div>
        </div>

        <div class="hidden sm:block">
          <div class="py-6">
            <div class="border-t border-gray-200"></div>
          </div>
        </div>

        <div class="md:inline-flex space-y-4 md:space-y-0 w-full p-4 items-center">

          <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Poste:</h2>

          <div class="md:w-2/3 mx-auto grid grid-cols-6 gap-6">

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Marque:</label>
              <multiselect v-model="form.phone.brand" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="brands"
                           :error="errors.brand" :searchable="true" @input="asyncFind" open-direction="bottom">
              </multiselect>
              <div v-if="errors.brand_id" class="form-error">{{ errors.brand_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Model:</label>
              <multiselect v-model="form.phone.model" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                           :options="modelsData" :searchable="true" :error="errors.model_id" :clear-on-select="false" :loading="loading"
                           open-direction="bottom">
              </multiselect>
              <div v-if="errors.model_id" class="form-error">{{ errors.model_id }}</div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <div v-if="form.phone.isReturn" class="bg-orange-400 rounded px-2 text-center w-20 float-right">
                <span class="font-medium text-white">Retour</span>
              </div>
              <text-input v-model="form.phone.imei" :error="errors.imei" label="IMEI" autocomplete="off"
                          @keyup.native="findImei"/>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <text-input v-model="form.phone.SN" :error="errors.SN" label="N° Série S/N" :optional="true" autocomplete="off"/>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <div v-if="form.phone.bounce" class="bg-orange-400 rounded px-2 text-center w-20 float-right">
                <span class="font-medium text-white">Rebond</span>
              </div>
              <select-input v-model="form.phone.malfunction" :error="errors.malfunction" label="Panne" @change.native="findMalfunction">
                <option value>----</option>
                <option v-for="malfunction in malfunctions" :value="malfunction.id">{{ malfunction.name }}</option>
              </select-input>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Garantie:</label>
              <div class="pl-2">
                <input v-model="form.phone.warranty" type="radio" name="warranty" value="1">
                <label>Constructeur</label>
              </div>
              <div class="pl-2">
                <input v-model="form.phone.warranty" type="radio" name="warranty" value="0">
                <label>Hors garantie</label>
              </div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Sauvegarde:</label>
              <div class="pl-2">
                <input v-model="form.phone.backup" type="radio" name="backup" value="1">
                <label>Oui</label>
              </div>
              <div class="pl-2">
                <input v-model="form.phone.backup" type="radio" name="backup" value="0">
                <label>Non</label>
              </div>
            </div>

            <div class="col-span-6 sm:col-span-2">
              <textarea-input v-model="form.phone.comment" :error="errors.comment" label="Commentaire" :optional="true" />
            </div>

          </div>
        </div>

        <div class="hidden sm:block">
          <div class="py-6">
            <div class="border-t border-gray-200"></div>
          </div>
        </div>

        <div class="md:inline-flex space-y-4 md:space-y-0 w-full p-4 items-center">
          <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Accesoires:</h2>

          <div class="md:w-2/3 mx-auto grid grid-cols-6 gap-6">
            <div class="col-span-6 sm:col-span-2">
              <label class="form-label">Accesoires:</label>
              <div class="px-2 py-1" v-for="accessory in accessories">
                <input v-model="form.phone.accessories" type="checkbox" class="form-checkbox" :value="accessory.id">
                <label>{{ accessory.name }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center mt-10">
          <loading-button :loading="sending" class="btn-indigo mx-2" type="submit">Sauvegarder</loading-button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TextareaInput from "@/Shared/TextareaInput";
import Multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
  metaInfo: {title: 'Reception de poste'},
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    JetActionMessage,
    TextareaInput,
    Multiselect,
    Loading
  },
  props: {
    errors: Object,
    repair: Object,
    cities: Array,
    operators: Array,
    agencies: Array,
    agents: Array,
    brands: Array,
    models: Array,
    malfunctions: Array,
    accessories: Array,
  },
  remember: 'form',
  data() {
    return {
      modelsData: this.models,
      clientTypes: ['comptoire', 'agence', 'particulier'],
      sending: false,
      isLoading: false,
      loading: false,
      form: {
        client: {
          first_name: this.repair.client ? this.repair.client.first_name : null,
          last_name: this.repair.client ? this.repair.client.last_name : null,
          email: this.repair.client ? this.repair.client.email : null,
          phone_number: this.repair.client ? this.repair.client.phone_number : null,
          type: this.repair.client ? this.repair.client.type : null,
        },
        phone: {
          imei: this.repair.product.imei,
          brand: this.repair.product.brand,
          model: this.repair.product.model,
          SN: this.repair.product.SN,
          malfunction: this.repair.product.malfunction_id,
          warranty: this.repair.product.under_warranty,
          backup: this.repair.product.backup,
          comment: this.repair.product.comment,
          accessories: this.repair.product.accessories.split(','),
          isReturn: this.repair.product.return,
          bounce: this.repair.product.bounced,
        },
        reception: {
          city: this.repair.city,
          operator: this.repair.operator,
          agency: this.repair.agency,
          agent: this.repair.agent,
          caseNo: this.repair.case_no,
        }
      },
    }
  },
  methods: {
    submit() {
      const data = new FormData()
      data.append('client', JSON.stringify(this.form.client) || '')
      data.append('phone', JSON.stringify(this.form.phone) || '')
      data.append('reception', JSON.stringify(this.form.reception) || '')
      data.append('_method', 'put')


      this.$inertia.post(this.route('receptions.update', this.repair.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    asyncFind() {
      this.loading = true
      return axios.get(this.route('stock.searchModel'), {params: {brand: this.form.phone.brand.id}})
        .then(response => {
          this.modelsData = response.data[0]
          this.loading = false
        })
    },
    findImei() {
      if (this.form.phone.imei == null || this.form.phone.imei.length < 5) {
        return
      }
      this.form.phone.isReturn = false
      this.form.phone.bounce = false
      this.isLoading = true
      return axios.get(this.route('product.search'), {params: {imei: this.form.phone.imei}})
        .then(response => {
          if (response.data[0] !== undefined) {
            if ( response.data[0].imei !== undefined && response.data[0].imei === this.form.phone.imei) {
              this.form.phone.isReturn = true
              this.findMalfunction()
            }
          }
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          alert(error)
          //this.form.error = error.response.data.errors.password[0];
        });
    },
    findMalfunction() {
      this.isLoading = true
      this.form.phone.bounce = false
      return axios.get(this.route('product.search'), {params: {imei: this.form.phone.imei, malfunction: this.form.phone.malfunction}})
        .then(response => {
          if (response.data[0] !== undefined) {
            if (response.data[0].id !== undefined && response.data[0].malfunction === this.form.phone.malfunction) {
              if (response.data[0].imei === this.form.phone.imei) {
                this.form.phone.bounce = true
              }
            }
          }
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          alert(error)
          //this.form.error = error.response.data.errors.password[0];
        });
    },
  },
  watch: {},
}
</script>
